import React, { useState } from 'react'

import styled from 'styled-components'
import OutsideClickHandler from 'react-outside-click-handler'

import { FiSearch } from 'react-icons/fi'
import { IoIosAdd } from 'react-icons/io'

import P from '../../../../../components/typography/P'

const Phrase = ({ phrase, onAddPhrase }) => {
  return (
    <StyledPhrase onClick={() => onAddPhrase(phrase)}>
      <AddIcon>
        <IoIosAdd />
      </AddIcon>
      <P>{phrase}</P>
    </StyledPhrase>
  )
}

const Phrases = ({ onAddPhrase, phrases, setShowPhrases }) => {
  const [filteredPhrases, setFilteredPhrases] = useState(phrases)

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase()
    const results = phrases.filter((phrase) =>
      phrase.toLowerCase().includes(query)
    )
    setFilteredPhrases(results)
  }

  return (
    <OutsideClickHandler onOutsideClick={() => setShowPhrases(false)}>
      <StyledPhrases>
        <SearchBar>
          <FiSearch />
          <input
            type="search"
            placeholder="Search phrases"
            onChange={handleSearch}
          />
        </SearchBar>
        <>
          {filteredPhrases.length > 0 ? (
            filteredPhrases.map((phrase, index) => (
              <Phrase key={index} phrase={phrase} onAddPhrase={onAddPhrase} />
            ))
          ) : (
            <P>No phrases found.</P>
          )}
        </>
      </StyledPhrases>
    </OutsideClickHandler>
  )
}

const StyledPhrase = styled.div`
  display: flex;
  cursor: pointer;
  gap: 0.75rem;
`

const AddIcon = styled.div`
  width: 1.25rem;
  height: 1.25rem;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgb(242, 243, 248);
  margin-top: 0.4rem;
`

const StyledPhrases = styled.div`
  width: 300px;
  height: 200px;
  position: absolute;
  top: 20%;
  left: 102%;
  width: 100%;
  max-width: 340px;
  padding: 1.25rem;
  background-color: rgb(255, 255, 255);
  border: 1px solid rgb(238, 238, 246);
  box-shadow: rgba(178, 178, 203, 0.2) 3px 3px 7px;
  border-radius: 3px;
  z-index: 77;
  overflow: auto;
  display: flex;
  gap: 0.75rem;
  flex-direction: column;

  @media (max-width: 768px) {
    left: 0px;
    top: 102%;
    width: 100%;
    max-width: 100%;
  }
`

const SearchBar = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  input[type='search'] {
    width: 100%;
    background: none;
    border: none;
    outline: none;
    font-size: 0.875rem;
    color: rgb(49, 55, 79);
    padding: 0px 0.5rem;
    font-weight: 300;
  }
`

export default Phrases
